// extracted by mini-css-extract-plugin
export default {"container":"_2mWEtsC0ze","logo-container":"_1y_vpoQMY4","logoContainer":"_1y_vpoQMY4","logo":"vDgtar6CM5","brand-logo":"_3s3ZCTynBr","brandLogo":"_3s3ZCTynBr","brand-logo-container":"_2JKIkQ_QZA","brandLogoContainer":"_2JKIkQ_QZA","vertical":"_1-bU535sVK","custom-branding":"_2IbKVRWoUN","customBranding":"_2IbKVRWoUN"};
    if(module.hot) {
      // 1622798361523
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  